import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';

const Humidity = props => {
    const { data, language } = props;

    return (
        <div className="wrapper-data-48h mc-widget-humidity24h">
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-humidity24h__labels">
                <div className="mc-widget-humidity24h__label">
                    <h3>{translate(language, 'municipal48h_hum_rel')} (%)</h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-humidity24h__data">
                {data.map((data, index) => (
                    <span key={index}>
                        {data.valor !== null ? Math.round(data.valor) : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

Humidity.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
};

export default Humidity;



// WEBPACK FOOTER //
// ./src/partials/Humidity.js